var lazy_images = document.querySelectorAll("[data-background]");

if (lazy_images) {
	window.addEventListener("load", function () {
		lazy_images.forEach(function (img) {
			var src = img.getAttribute("data-background");
			img.style.backgroundImage = "url(" + src + ")";
		});
	});
}

var lazy_videos = document.querySelectorAll("[data-apvideo]");

if (lazy_videos) {
	window.addEventListener("load", function () {
		lazy_videos.forEach(function (video) {
			var src = video.getAttribute("data-apvideo");
			var poster = video.getAttribute("data-poster");
			var html = `<video muted autoplay loop poster="${poster}"><source src="${src}" type="video/mp4" /></video>`;
			video.innerHTML = html;
		});
	});
}
